import { nanoid } from 'nanoid'
import { useRef } from 'react'

export const useNanoId: () => string = () => useRef(nanoid()).current
